export const DEFAULT_UNIT = 'unit-1'
export const CORE_UNITS_LABEL = 'Core'
export const BULLYING_UNITS_LABEL = 'Recognizing Bullying & Harassment'
